export const decodeBase64Url = (str) => {
    try {
        // Convert base64url to base64
        let base64 = str.replace(/-/g, '+').replace(/_/g, '/');

        // Add padding if needed
        while (base64.length % 4) {
            base64 += '=';
        }

        // Decode base64
        const decoded = atob(base64);

        // Convert to UTF-8
        const utf8Decoder = new TextDecoder('utf-8');
        const uint8Array = new Uint8Array(decoded.split('').map(char => char.charCodeAt(0)));
        return utf8Decoder.decode(uint8Array);
    } catch (error) {
        console.error('Error decoding base64:', error);
        return str; // Return original if decoding fails
    }
};

export const decodeHtmlEntities = (text) => {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
};